/**
 * usePermission Hook
 * Hook สำหรับตรวจสอบสิทธิ์การใช้งาน
 */

import { useAuth } from '../contexts/AuthContext';

export const usePermission = () => {
  const { user, permissions, hasPermission } = useAuth();

  return {
    // ฟังก์ชันตรวจสอบสิทธิ์
    hasPermission,

    // ตรวจสอบว่าเป็น Super Admin หรือไม่
    isSuperAdmin: user?.is_superadmin || false,

    // ตรวจสอบว่าเป็น Super User หรือไม่
    isSuperUser: user?.is_superuser || false,

    // Permissions object
    permissions,

    // Helper functions สำหรับ CRUD operations
    canView: (module: string) => hasPermission(`${module}.view`),
    canCreate: (module: string) => hasPermission(`${module}.create`),
    canEdit: (module: string) => hasPermission(`${module}.edit`),
    canDelete: (module: string) => hasPermission(`${module}.delete`),
    // ISSUE-S053-EXPORTGATE (PO 2026-08-19): mirror backend require_export_permission —
    // export ผ่านได้เมื่อมี `{module}.export` หรือ `exports.view` อย่างใดอย่างหนึ่ง
    canExport: (module: string) =>
      hasPermission(`${module}.export`) || hasPermission('exports.view'),

    // Helper สำหรับ billing
    canSend: (module: string) => hasPermission(`${module}.send`),
    canConfirm: (module: string) => hasPermission(`${module}.confirm`),
    canCancel: (module: string) => hasPermission(`${module}.cancel`),
    canRefund: (module: string) => hasPermission(`${module}.refund`),
    canDownload: (module: string) => hasPermission(`${module}.download`),

    // ตรวจสอบหลายสิทธิ์พร้อมกัน (ต้องมีทั้งหมด)
    hasAllPermissions: (permissionList: string[]) => {
      if (user?.is_superadmin) return true;
      return permissionList.every(p => hasPermission(p));
    },

    // ตรวจสอบหลายสิทธิ์พร้อมกัน (มีอย่างน้อย 1 อัน)
    hasAnyPermission: (permissionList: string[]) => {
      if (user?.is_superadmin) return true;
      return permissionList.some(p => hasPermission(p));
    },
  };
};

export default usePermission;
